module.exports = __webpack_public_path__ + "static/img_2034-ad6e69886eccc68c93fe105e02bb0905.webp";